import { Message } from "~/shared/ui/kit/components/Message"
import { ErrorResponse } from "react-router-7"

export function ErrorMessage(props: { error: Error | ErrorResponse | string | null }) {
	return (
		<Message type="error">
			{typeof props.error === "string"
				? props.error
				: ((props.error as Error)?.message ?? (props.error as ErrorResponse)?.data ?? "Неизвестная ошибка")}
		</Message>
	)
}
